<template>
  <a-modal
      :title="`${actType}权限`"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showForm"
      :confirmLoading="loading"
      @cancel="close"
  >
    <a-form-model
        ref="form"
        :model="model"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <a-form-model-item label="名称" prop="name" ref="name">
            <a-input v-model="model.name" />
          </a-form-model-item>

          <a-form-model-item label="父级权限" v-if="privileges.length > 0">
            <a-tree-select
              v-model="model.parent_id"
              style="width: 100%"
              placeholder="一级菜单"
              allow-clear
              :tree-data="privileges"
              :replace-fields="replaceFields"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            />
          </a-form-model-item>

          <a-form-model-item label="权限标识" help="格式：控制器@方法(如UserController@index)">
            <a-input v-model="model.route" />
          </a-form-model-item>
          <a-form-model-item label="前端路径" help="前端路由名称">
            <a-input v-model="model.url" />
          </a-form-model-item>
          <a-form-model-item label="图标" help="支持Ant Design内置图标库">
            <a-input v-model="model.icon" />
          </a-form-model-item>
          <a-form-model-item label="排序值" help="数字，越小越靠前">
            <a-input v-model="model.sort" />
          </a-form-model-item>
          <a-form-model-item label="隐藏" help="隐藏后管理员将无法从后台找到该菜单入口">
            <a-switch v-model="model.hidden" />
          </a-form-model-item>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'
export default Create
</script>
